export const customerReviews = [
  {
    "name": "Nitish Patel",
    "age&occupation": "66, Business Owner",
    "message": "Fix Health transformed my healthcare experience! The online consultations were so convenient, and the doctors were knowledgeable and caring."
  },
  {
    "name": "Rashmi",
    "age&occupation": "43, Hr Professional",
    "message": "I found the perfect specialist for my condition through Fix Health. The personalized treatment plan made all the difference. Thank you for prioritizing my health!"
  },
  {
    "name": "Pranjal Deep",
    "age&occupation": "29, Designer",
    "message": "Booking appointments was a breeze, and the service exceeded my expectations. The doctors truly listen and provide effective solutions. 5 stars!"
  },
  {
    "name": "Dr Nashir Kamal",
    "age&occupation": "64, General Physician",
    "message": "Fix Health is a game-changer! The emergency care saved me during a critical situation. Grateful for their quick and efficient support."
  },
  {
    "name": "Rajesh Chainani",
    "age&occupation": "54, Senior Director",
    "message": "I used to dread hospital visits, but Fix Health made it a pleasant experience. The doctor was  professional. I'll definitely be back!"
  },
  {
    "name": "Robert Wilson",
    "age&occupation": "50, consultant",
    "message": "Finally, a healthcare platform that puts patients first! The service provided comprehensive care and regular follow-ups. Thank you, Fix Health!"
  },
  {
    "name": "Mary Lee",
    "age&occupation": "30, Data Scientist",
    "message": "I've been using Fix Health for a variety of health concerns, and each time, I received exceptional care. It's my go-to for all medical needs!"
  },
  {
    "name": "David Miller",
    "age&occupation": "40, Engineer",
    "message": "I highly recommend Fix Health for online consultations. It's convenient, secure, and the doctors are top-notch. Great job, team!"
  }  
];
